/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 24/03/2025
*/

import React from 'react'
import { Typography } from '@mui/material';
import Styles from './productsIntro.module.css';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import ProductBackGround from '../../assets/images/product/productCover-BlackBox3.png';


const HR = () => {

  return (


    <>
      <div className={Styles.topContentMainContainerHr}>
        <img src={ProductBackGround} className={Styles.productCoverBlackBox} />
        <div className={Styles.topContentBox}>
          <Typography variant='h2' className={Styles.productTopHeader} >HR Management System</Typography>
          <Typography variant='h6' className={Styles.productTopBody}>Welcome to our cutting-edge Online Human Resource System—an
            intelligent, user-friendly platform designed to streamline HR processes, empower your teams,
            and elevate your organization.Step into the future of HR management with our Online Human Resource System. Simplify processes,
            boost productivity, and nurture a thriving workplace culture. </Typography>
        </div>
      </div>

      <div className={Styles.outerContainer}>
        <Typography variant='h5' className={Styles.titelFirsttxt} >KEY FEATURES</Typography>
        <div className={Styles.descriptionContainer}>

          <div>
            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Centralized HR Management:</Typography>
                <Typography className={Styles.descriptionText}>
                  Experience the convenience of managing all HR functions from a centralized platform. Our system seamlessly integrates employee data, attendance records, performance evaluations, and more in one secure location.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Employee Self-Service Portal:</Typography>
                <Typography className={Styles.descriptionText}>
                  Empower your workforce with a self-service portal where they can access their information, request time off, view pay stubs, and update personal details. This enhances communication and engagement while reducing administrative workload.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Recruitment and Applicant Tracking:</Typography>
                <Typography className={Styles.descriptionText}>
                  Simplify your hiring process with our intuitive recruitment module. Post job openings, manage applications, and track candidates seamlessly, ensuring a smooth recruitment journey from start to finish.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Performance Management and Reviews:</Typography>
                <Typography className={Styles.descriptionText}>
                  Elevate employee performance through our performance management tools. Set objectives, conduct reviews, and provide constructive feedback to drive growth and development within your organization.
                </Typography>
              </div>
            </div>

          </div>

          <div>
            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Learning and Development:</Typography>
                <Typography className={Styles.descriptionText}>
                  Invest in your team's skills and knowledge with our comprehensive learning and development module. Easily create, assign, and track training programs, empowering your workforce to grow and excel.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Customizable Reporting and Analytics:</Typography>
                <Typography className={Styles.descriptionText}>
                  Access actionable insights through customizable reports and analytics. Measure key HR metrics, analyze trends, and make data-driven decisions to enhance your HR strategies and operations.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Data Security and Compliance:</Typography>
                <Typography className={Styles.descriptionText}>
                  Safeguard sensitive HR data with our robust security measures. Our system complies with industry standards to ensure your data is protected and remains compliant with regulations.
                </Typography>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>






  );
}

export default HR;